/* eslint-disable react/style-prop-object */
import Typography from '@alltrails/shared/denali/components/Typography';
import { FormattedMessage, FormattedNumber } from '@alltrails/shared/react-intl';
import useIsMobileSizedScreen from 'components/NavigationHeader/useIsMobileSizedScreen';
import useUser from 'hooks/useUser';

const PeakSubheading = () => {
  const { currencyCode } = __AT_DATA__;
  const { plans } = __AT_DATA__;
  const user = useUser();
  const isMobileSizedScreen = useIsMobileSizedScreen();
  const isPromoEligible = user?.isPromoEligible;

  const promoEligibleText = isMobileSizedScreen ? (
    <FormattedMessage
      defaultMessage="7 days free, then {annualCost}/year"
      values={{
        annualCost: <FormattedNumber currency={currencyCode} style="currency" value={plans.peak.priceTotal} />
      }}
    />
  ) : (
    <FormattedMessage
      defaultMessage="7 days free, then {annualCost}/year (that’s {monthlyCost}/month)"
      values={{
        annualCost: <FormattedNumber currency={currencyCode} style="currency" value={plans.peak.priceTotal} />,
        monthlyCost: <FormattedNumber currency={currencyCode} style="currency" value={plans.peak.priceMonth} />
      }}
    />
  );

  return (
    <Typography component="div" variant="text200">
      {isPromoEligible ? (
        promoEligibleText
      ) : (
        <FormattedMessage
          defaultMessage="{annualCost}/year (that’s {monthlyCost}/month)"
          values={{
            annualCost: <FormattedNumber currency={currencyCode} style="currency" value={plans.peak.priceTotal} />,
            monthlyCost: <FormattedNumber currency={currencyCode} style="currency" value={plans.peak.priceMonth} />
          }}
        />
      )}
    </Typography>
  );
};

export default PeakSubheading;
